module.exports = __webpack_public_path__ + "img/Rangers.623dbf2b.jpg";